// extracted by mini-css-extract-plugin
export default {"colorPallete":"mystyles_colorPallete__6ZXw1","color":"mystyles_color__TuGCs","color1":"mystyles_color1__ESaPw","color2":"mystyles_color2__fr2aM","color3":"mystyles_color3__REzeF"};